import React, { useState, useEffect } from 'react';
import { Alert, Container, Dropdown } from 'react-bootstrap';
import { FaCloud, FaDatabase, FaFolderOpen, FaServer } from 'react-icons/fa';
import ManagedSourcesTable from './ManagedSourcesTable';
import { useParams } from 'react-router-dom';
import PageHeader from 'Utils/PageHeader';
import { useCanEdit } from 'Auth/permissions';
import { CATEGORIES, isCategory } from '../LandscapeUtils';

const CATEGORY_HEADER = {
  rdbm: { label: 'Databases', Icon: FaDatabase },
  files: { label: 'File Storage', Icon: FaFolderOpen },
  servers: { label: 'Servers', Icon: FaServer },
};

const ManagedSources = (props) => {
  const [managedSources, setManagedSources] = useState();
  const { source } = useParams();
  const canEdit = useCanEdit();

  useEffect(() => setManagedSources(props.managedSources), [props.managedSources]);

  const categoryHeader = isCategory(source) ? CATEGORY_HEADER[source] : null;
  // The nav says "Cloud Landscape"; the page said "Managed Sources" (or the category). One name
  // for the page, with the category as the eyebrow.
  const header = 'Cloud Landscape';
  const eyebrow = categoryHeader ? categoryHeader.label : 'Managed sources';
  const Icon = categoryHeader ? categoryHeader.Icon : FaCloud;
  const tooltip = categoryHeader
    ? `All ${CATEGORIES[source].label.toLowerCase()} across AWS, Azure, and GCP.`
    : 'The following sources have been detected across your enabled cloud providers (AWS, Azure, GCP).';

  return (
    <Container fluid>
      <div>
        <PageHeader
          header={header}
          eyebrow={eyebrow}
          icon={Icon}
          help='Cloud resources (databases, file storage, servers) found in your connected AWS, Azure and GCP accounts that may hold data needing discovery.'
          tooltip={tooltip}
          actions={[
            <Dropdown.Item key='refresh' disabled={!canEdit} onClick={async () => props.refreshStatus()}>
              {props.fetchingData ? 'Refreshing…' : 'Refresh sources'}
            </Dropdown.Item>
          ]}
        />

        { props.fetchingData ? (
          <Alert key={"refreshing-info"} variant={"info"}>
            Updating resource list...
          </Alert>
        ) : (null)}

        <ManagedSourcesTable
          managedSources={managedSources}
          showTabs={true}
          fetchingData={props.fetchingData}
          source={source}
          refreshStatus={ () => props.refreshStatus()}
          onActionStarted={props.onActionStarted}
        />
      </div>
    </Container>
  );
}
export default ManagedSources;
